var initializeBlockVideo = function(block){
    
    jQuery('.modal-youtube', block).modalVideo();
	jQuery('.modal-vimeo', block).modalVideo({channel:'vimeo'});
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-video').each(function(){
        initializeBlockVideo(jQuery(this));
    });
}); 

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=video', initializeBlockVideo);
 